module.exports = __webpack_public_path__ + "img/up-waiting.a426ff1e.png";